import { Div } from 'ui'
import useResponsive from 'utils/hooks/useResponsive'
import React from 'react'

const ImgWrapper = ({ children }) => {

  const { isTab } = useResponsive()

  return (
    <Div
    gridArea='img'
    textAlign={isTab ? 'center' : 'right'}
    marginBottom={isTab ? 40 : 80}
    // border='5px solid blue'
    width='100%'
  >
    <Div
      maxWidth={isTab ? 365 : 465}
      // border='5px solid red'
      marginLeft='auto'
      marginRight={isTab ? 'auto' : 0}
      width='90%'
    >
      {children}
    </Div>
  </Div>
  )
}

export default ImgWrapper